import * as React from 'react'
import './CustomMetricsLanding.css'
import { MonitoringWhiteSvg } from './MonitoringWhiteSvg'

export type ValueProps = {}

export type Props = ValueProps

const text1 = 'No custom metrics are being collected for this application.'
const text2 = 'You can use the Custom Metrics connector in your application flow to collect metrics specific to your operational and business needs.'
const text3 = 'Once your application is deployed the defined custom metrics charts will automatically appear in this tab.'
const landingMessage = `${text1} ${text2} ${text3}`

export const CustomMetricsLanding = () => {
  return (
    <div className="custom-metrics-landing">
      <div className="custom-metrics-landing-title">
        <span>Custom Metrics</span>
      </div>
      <div className="custom-metrics-landing-description">
        {landingMessage}
      </div>
      <div className="custom-metrics-landing-link">
        <a href="https://docs.mulesoft.com/connectors/metrics/custom-metrics-connector" target="_blank">Learn how to set up Custom Metrics</a>
      </div>
      <div className="custom-metrics-landing-icon">
        <MonitoringWhiteSvg />
      </div>
    </div>
  )
}